import React from 'react';
import {
  TableData,
  TableRow,
  formatHash,
  HashLength,
  formatTimestamp,
  Tooltip,
  formatTimestampAge,
  Link
} from '@make-software/cspr-design';

import { StampAction, MINT_ACTION, BURN_ACTION, TRANSFER_ACTION, APPROVE_ACTION } from '@/entities';
import { AccountInfoCell } from './account-info-cell';
import { HistoryLink } from './history-link';

import { StyledStampActionText, StyledTimeText } from './styled';

interface StampActionTableRowProps {
  stampAction: StampAction;
}

export const StampActivityTableRow: React.FC<StampActionTableRowProps> = ({ stampAction }) => {
  const transactionLink = `${config.cspr_live_url}/transaction/${stampAction.transactionHash}`;

  let action = '';
  switch (stampAction.ftActionTypeId) {
    case MINT_ACTION: action = 'Purchased'; break;
    case BURN_ACTION: action = 'Affixed to message'; break;
    case APPROVE_ACTION: action = 'Approved for spend'; break;
    case TRANSFER_ACTION: action = 'Transferred'; break;
  }
  return (
    <TableRow>
      <TableData>
        <StyledStampActionText size={3} scale="sm">
          {action}
        </StyledStampActionText>
      </TableData>

      {/*<TableData>*/}
      {/*  <AccountInfoCell*/}
      {/*    accountHash={StampAction.recipientPublicKey}*/}
      {/*    publicKey={StampAction.recipientPublicKey}*/}
      {/*  />*/}
      {/*</TableData>*/}

      <TableData>
        <StyledStampActionText size={3} scale="sm" monotype>
          {stampAction.amount} STAMP
        </StyledStampActionText>
      </TableData>

      <TableData>
        <Tooltip
          scale={'xs'}
          lineHeight={'xs'}
          paddingScale={1}
          tooltipContent={formatTimestamp(stampAction.timestamp)}
          monotype>
          <StyledTimeText size={3} noWrap>
            <HistoryLink href={transactionLink} target={'_blank'} monotype>
              {formatTimestampAge(stampAction.timestamp)}
            </HistoryLink>
          </StyledTimeText>
        </Tooltip>
      </TableData>
    </TableRow>
  );
};
